/** @jsx jsx */
import { jsx, css, Global } from '@emotion/react';
import { ChangeEvent, Component } from 'react';
import { Layout, Menu } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router';
import { DashRoute } from '../../_shared/interfaces/dashroute';
import styles, { GlobalInserts } from './header.styles';
import Logo from '../../_shared/logo';
import colors from '../../_shared/colors';
import { Ellipsis } from './ellipsis.component';
import { connect } from 'react-redux';
import { filterEquipment, setEquipFiltersOpen } from '../dashboard.actions';
import { AppState } from '../../app.state';
import { DashEquipFilters } from '../dashboard.reducer';
import { isPB } from '../../utils';
import { Search } from './search.component';
import { get } from 'lodash';

const FiltersIcon = ({ color, size = 22 }: { color: string; size?: number }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="1.25"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <line x1="3" y1="6" x2="13" y2="6" />
    <line x1="17" y1="6" x2="21" y2="6" />
    <circle cx="15" cy="6" r="1.6" fill={color} />
    <line x1="3" y1="12" x2="7" y2="12" />
    <line x1="11" y1="12" x2="21" y2="12" />
    <circle cx="9" cy="12" r="1.6" fill={color} />
    <line x1="3" y1="18" x2="15" y2="18" />
    <line x1="19" y1="18" x2="21" y2="18" />
    <circle cx="17" cy="18" r="1.6" fill={color} />
  </svg>
);

interface IProps extends RouteComponentProps {
  routes: DashRoute[];
  ellipsisRoutes: DashRoute[];
  changeRoute: (route: DashRoute) => void;
  filterEquipment: (filters?: DashEquipFilters) => void;
  setEquipFiltersOpen: (open: boolean) => void;
  sState: AppState;
  showSearch?: boolean;
  searchValue: string | undefined;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

export class HeaderComponent extends Component<IProps> {
  logoClick = () => {
    const { sState } = this.props;
    const role = get(sState, 'auth.user.role');

    if (role !== 5) {
      this.props.history.push('/dashboard');
    }
  };

  toggleFilters = () => {
    const { sState } = this.props;
    const open = !!get(sState, 'dash.view.equipFiltersOpen');
    this.props.setEquipFiltersOpen(!open);
  };

  render() {
    const { routes, changeRoute, ellipsisRoutes, sState, location } = this.props;
    const isPhoneBreak = isPB(sState);
    const role = get(sState, 'auth.user.role');
    const showSearch = get(this.props, 'showSearch', true);
    const onDashboard = location.pathname === '/dashboard';

    if (isPhoneBreak) {
      return (
        <Layout.Header css={css(styles.pbContainer)}>
          <Global styles={GlobalInserts} />
          {onDashboard && role !== 5 ? (
            <div css={css(styles.pbFilterButton)} onClick={this.toggleFilters}>
              <FiltersIcon color={colors.highlight} />
            </div>
          ) : (
            <div css={css(styles.pbFilterButton)} />
          )}
          <div css={css(styles.pbLogoWrap)}>
            <Logo height={50} type="aeras_i" onClick={this.logoClick} />
          </div>
          <Ellipsis {...this.props} routes={ellipsisRoutes} />
        </Layout.Header>
      );
    }

    return (
      <Layout.Header css={css(styles.container)}>
        <Global styles={GlobalInserts} />
        <Logo
          height={50}
          type="aeras_i"
          style={{ marginLeft: 10, marginRight: 20 }}
          onClick={this.logoClick}
        />
        {!isPhoneBreak && (
          <div css={css(styles.menuContainer)}>
            <Menu
              mode="horizontal"
              css={css(styles.menu)}
              defaultSelectedKeys={['0']}
              items={routes.map((route, i) => ({
                label: route.title,
                key: i,
                onClick: () => changeRoute(route),
              }))}
            />
          </div>
        )}
        {!isPhoneBreak && role !== 5 && showSearch && (
          // @ts-ignore: filterEquipment, sState, history, location, match injected by connect/withRouter
          <Search
            //@ts-ignore
            searchValue={this.props.searchValue}
            //@ts-ignore
            onChange={this.props.onChange}
          />
        )}
        <Ellipsis {...this.props} routes={ellipsisRoutes} />
      </Layout.Header>
    );
  }
}

export const Header = connect(
  (sState: AppState) => ({ sState }),
  {
    filterEquipment,
    setEquipFiltersOpen,
  }
  //@ts-ignore
)(withRouter(HeaderComponent) as any) as unknown as typeof HeaderComponent;
